import type { ErrorConfiguracion } from '@/configuracion/entorno';

interface PropiedadesPanelError {
  readonly error: ErrorConfiguracion;
}

/**
 * Pantalla de fallo de configuracion (requisito de ADR-032 y CLAUDE.md §5).
 *
 * Se muestra en lugar de la aplicacion cuando falta configuracion fuera del modo
 * emulador. Dice exactamente que falta y como resolverlo, en vez de una pantalla en
 * blanco o un error de consola que solo entiende quien escribio el codigo.
 *
 * `role="alert"` hace que los lectores de pantalla lo anuncien de inmediato.
 */
export function PanelErrorConfiguracion({ error }: PropiedadesPanelError): React.JSX.Element {
  return (
    <section className="panel panel--error" role="alert" aria-labelledby="titulo-error-config">
      <h2 className="panel__titulo" id="titulo-error-config">
        Falta configuracion para arrancar
      </h2>

      <p>
        La aplicacion no puede iniciarse porque no esta apuntando a los emuladores y le faltan
        variables de entorno.
      </p>

      {error.faltantes.length > 0 && (
        <>
          <h3 className="panel__titulo">Variables sin definir</h3>
          <ul>
            {error.faltantes.map((nombre) => (
              <li key={nombre}>
                <code>{nombre}</code>
              </li>
            ))}
          </ul>
        </>
      )}

      {error.placeholders.length > 0 && (
        <>
          <h3 className="panel__titulo">Variables con el placeholder sin reemplazar</h3>
          <ul>
            {error.placeholders.map((nombre) => (
              <li key={nombre}>
                <code>{nombre}</code>
              </li>
            ))}
          </ul>
        </>
      )}

      <h3 className="panel__titulo">Como resolverlo</h3>
      <pre className="detalle-error">{error.mensaje}</pre>
    </section>
  );
}
